import _ from 'lodash'
import { MutationTree } from 'vuex'
import {
  GroupsState,
  Group,
} from '@/store/groups/types';
import { Pager } from '../pager.types';

const mutations: MutationTree<GroupsState> = {
  /**
   * グループ一覧情報を設定
   * @param {{
   *   pager: Pager,
   *   groups: Group[]
   * }} payload グループ一覧情報
   */
  fetchedGroups: (state, payload: {
    pager: Pager,
    groups: Group[],
  }) => {
    state.groups = payload.groups
    state.pager = payload.pager
  },

  /**
   * グループ詳細情報を設定
   * @param {Group} group 取得したグループ詳細情報
   */
  gotGroup: (state, group: Group) => {
    state.groups = _.uniqBy([
      group,
      ...state.groups,
    ], 'id')
  },

  /**
   * 作成したグループのIDを設定
   * @param state
   * @param {string} createdId
   */
  createdGroup: (state, createdId: string) => {
    state.createdId = createdId
  },
};

export default mutations;
